LiveForm.setOptions({
    wait: 500,
    messageErrorPrefix: '&nbsp;<i class="material-icons error-icon">error</i>&nbsp;',
});

// vlastní chybové elementy  LiveForm
LiveForm.getMessageId = el => el.id + LiveForm.options.messageIdPostfix; // nepokoušej se vymýšlet unikátní ID: pokud je element v šabloně, použij ten
LiveForm.options.messageErrorClass = "error"; // bohužel nejde nastavit, aby se zprávám nepřepisovala třída javascriptem; ignoruj messageErrorPrefix
//LiveForm.options.messageErrorPrefix = ""; // LFV jako výchozí vnucuje vlastní prefix
LiveForm.processServerErrors = _=>_; // nepokoušej se odstraňovat chybové elementy

